export const paths = {
  Login: '/login',
  Callback: '/callback',
  Assistant: '/assistant',
  AssistantAgent: '/assistant/:agentId',
  Root: '/',
  TestCanvas: '/test-canvas',
  TestEventOrchestration: '/test-event-orchestration',
  TestIncidentWorkflow: '/test-incident-workflow',
  TestScroll: '/test-scroll',
  ColorPalette: '/colors',
  BestPractices: '/best-practices',
  BestPracticesOverview: '/best-practices/overview',
  BestPracticesUsers: '/best-practices/users',
  BestPracticesTeams: '/best-practices/teams',
  BestPracticesContactMethods: '/best-practices/contact-methods',
  BestPracticesSchedules: '/best-practices/schedules',
  BestPracticesFlexibleSchedules: '/best-practices/flexible-schedules',
  BestPracticesNotificationRules: '/best-practices/notification-rules',
  BestPracticesEscalationPolicies: '/best-practices/escalation-policies',
  BestPracticesServices: '/best-practices/services',
  BestPracticesAIOps: '/best-practices/aiops',
  BestPracticesIW: '/best-practices/incident-workflows',
} as const;
